import React from 'react';
import PropTypes from 'prop-types';

/**
 * A card component displaying the user's carbon savings information
 * 
 * @param {Object} props - Component props
 * @param {number} props.savings - Carbon savings in kg
 * @param {string} props.period - The period for which savings are shown (e.g., "This Month")
 */
const CarbonSavingsCard = ({ savings, period = 'This Month' }) => {
  return (
    <div className="card bg-white shadow-md rounded-lg p-6">
      <h2 className="text-gray-500 text-sm font-semibold uppercase mb-2">Carbon Savings {period}</h2>
      <div className="flex items-baseline">
        <span className="text-3xl font-bold text-green-600">
          {(typeof savings === 'number' ? savings.toFixed(2) : '0.00')} kg
        </span>
      </div>
      <div className="text-sm text-gray-500 mt-1">
        CO2 emissions saved
      </div>
    </div>
  );
};

CarbonSavingsCard.propTypes = {
  savings: PropTypes.number,
  period: PropTypes.string
};

export default CarbonSavingsCard; 